//
import Vue from "vue"
import Router from "vue-router"

// 
import auth from "./auth"
import dashboard from "./dashboard"
import guard from "./guard"

//
Vue.use(Router)

//
const router = new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes: [
        ...dashboard,
        ...auth,
    ],
})

// global guard for router ( redirect to Login if user is not authenticated )
router.beforeEach( guard )

//
export default router